import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import {constants, moment} from './common/commonExport';
import * as actions from "../actions/index";


class ExcelExportData extends React.Component{
    constructor(props) {
        super(props);
        this.state = { // default state for component
            params: this.props.Params,
            pageNumberInput:'',
            printStatus:false,
            filterState:{}
        }
    }
  
    render() {
        const { printStatus } = this.props.printState;
        let hidden = this.props.hidden;
        let validWorkday = this.props ? this.props.validWorkday : '';
        let dutyActivityStatus = this.props.workday ? this.props.workday.dutyActivityStatus : '';
        const isModalOpened = this.props.showModal;
        return (
                <div className={"printContainer " + (printStatus || hidden || this.props.isLoading || (dutyActivityStatus == 'N' && !validWorkday && isModalOpened)  ? 'hidden' : '')}>
                    <button className={"btn btnWidth btn-primary"} onClick={this.getData.bind(this)}>Excel <i className="fa fa-table" aria-hidden="true"></i></button>
                </div>
        )
    }

    // getting data to print
    getData() { 
        
        let isPre16 = this.props.details && this.props.details == "Pre16";
        let pageNo = this.props.pageNo;
        let duty_activity = this.props.data,
            role = this.props.authDetails.role;
        
        this.props.printProgress(true);  
        this.setState({
            printStatus:true
        }); 
        const route = localStorage.getItem('route');                  
        const { getSelectedCheckedData } = this.props;
        let selectedRows = getSelectedCheckedData();
        const filter = this.props.filterState;
        let  filterObj =  {selectedRows, ...filter},
       
        url = route == constants.ADMIN_HOS_LOG ? constants.actionUrls.ADMIN_HOS_LOGS_URL 
                    : route == constants.FRA_REPORT ? constants.actionUrls.GET_FRA_LIST 
                    : role == constants.roles.EMPLOYEE_ROLE ? constants.actionUrls.WORKDAY_URL 
                    : isPre16 ? constants.actionUrls.ADMIN_NCNP_URL 
                    : route == constants.SERIES14 ? constants.actionUrls.GET_ALL_USER_SERIES 
                    : constants.actionUrls.ADMIN_URL;
                              


        let fetchObj = {
            url:url,
            role: role,
            pageNum: pageNo ? pageNo : 1,
            certifyStatus:localStorage.getItem('route'),
            byPrint:true,
            filterObj:filterObj,
            fraExportExcel:true
        };
         let self = this;
         if(role != constants.roles.EMPLOYEE_ROLE) 
         {
          this.props.fetchDataToPrint(fetchObj, function(data){
            if(data)
            {
                          self.printDetails(data,function(){self.props.printProgress(false);});   
            } 
            else {
                self.props.printProgress(false);
                        }                    
                });
        } else {
                this.props.onActErr(true, false, constants.errMessages.printError); // para1: errpop, para2: acterr
                this.props.printProgress(false);
            }
            
    };


    // print function
    printDetails(data, callback) {      
        import("xlsx").then((XLSX) => {
            this.props.printProgress(true);
            let currentDate = moment(new Date()).format("MMM Do YYYY");
            let printData = this.formatExcelData(data)

            if (data && data.length > 0) {
                var new_workbook = XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(printData);
                XLSX.utils.book_append_sheet(new_workbook, worksheet, 'ReportData');
                this.props.printProgress(true);
                XLSX.writeFile(new_workbook, 'FRA_Report_' + currentDate + '.xlsx');
            } else {
                this.props.printProgress(false);
            }
            this.setState({ printStatus: false });   
            if (callback) callback();
        });
            
    } ;  



    formatExcelData(data)
    {
    
      let formattedData =[]
    
      let blankRow={
         'WorkDate':''
        ,'EmployeeID': ''
        , 'FullName':''
        ,'JobType':''
        ,'JobClass':''
        ,'Division':''        
        ,'HOSActivityName':''
        ,'CreatedBy':''
        ,'ActivityStartPlace':''
         ,'ActivityStartTime':''
        ,'AcivityEndPlace':''
         ,'ActivityEndTime':''         
         ,'comments':''
         ,'CertifyDate':''
         ,'CertifyStatus':''
         ,'WorkDayPlaceStart':''
         ,'WorkDayPlaceEnd':''
         ,'CreatedDatetime':''
         ,'WorkDayJobSymbol':''
    }
    
     
      for (let index = 0; index < data.length; index++) {
  
          if(((index == 0) || data[index -1].EmployeeID != data[index].EmployeeID || data[index-1].WorkDate != data[index].WorkDate))
          {
    
            let headerRow={
                'WorkDate':data[index].WorkDate
                ,'EmployeeID': data[index].EmployeeID
                , 'FullName':''               
               ,'JobType':''
               ,'JobClass':''
               ,'Division':''               
               ,'HOSActivityName':''
               ,'CreatedBy':''
               ,'ActivityStartPlace':''
                ,'ActivityStartTime':''
               ,'AcivityEndPlace':''
                ,'ActivityEndTime':''               
                ,'comments':''
                ,'CertifyDate':''
                ,'CertifyStatus':''
                ,'WorkDayPlaceStart':''
                ,'WorkDayPlaceEnd':''
                ,'CreatedDatetime':''
                ,'WorkDayJobSymbol':''
           }
    
           formattedData.push(blankRow);
           formattedData.push(headerRow);
           formattedData.push(blankRow);    
           formattedData.push(data[index]);
    
          }
          else
          {
            formattedData.push(data[index]);
          }
         
    
    
            
      }
    
    return formattedData
    
    
    }
    

}




function mapStateToProps(state) {
    return { 
        PaginationState: state.Pagination, 
        filterState:state.filter,
        authDetails:state.authState,
        printState:state.printState,
        workday: state.workday.workday,
        showModal: state.modals.showModal
     };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        printProgress:actions.printProgressAction,
        fetchDataToPrint:actions.fetchDataToPrintAction,
        onActErr: actions.actErrorAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(ExcelExportData);


